/* eslint-disable no-useless-concat */
/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import _find from 'lodash/find.js';
import { uploadImagesSelector } from '../selectors';
import {
  uploadImagePositions,
  removeBackgrounds,
  imageSizes,
  imagePlacements,
  imagePlacementValues,
} from './data/uploadImageConstants';

export const getSpecificUploadImage = (id, uploadImages) =>
  uploadImages.filter((uploadimage) => uploadimage.id === id)[0];
export const getOtherImages = (id, uploadImages) =>
  uploadImages.filter((uploadImage) => uploadImage.id !== id);

export const getUploadImageChoiceValue = (state) => {
  const { uploadImagesUrl } = uploadImagesSelector(state);
  return uploadImagesUrl || null;
};

export const getUploadImageChoice = (choices) => {
  const uploadImagesChoice = Object.values(choices).filter(
    (ch) => ch.internalName === 'UploadLogo_PPE'
  )[0];
  return uploadImagesChoice;
};

export const getFileExtension = (file) => {
  const lastIndex = file.lastIndexOf('.');
  return file.substring(lastIndex + 1);
};

export const findUploadImagePositionInString = (uploadUrlString) =>
  uploadImagePositions.filter((position) => uploadUrlString.includes(position));

export const getUploadedPositions = (uploadImageParams, uploadedImages) => {
  const uploadImages = [];

  const generateUploadImage = (item, id, tabPosition) => {
    const subItems = item.split('-');
    const position = tabPosition.toLowerCase();
    const removeBackground = subItems[1];
    const fileExtension = subItems[subItems.length - 1];
    const imageSize = subItems[2];
    const imagePlacement = subItems[3];
    const logoColor = subItems[4];
    // const subUrl = `${position}_${newLineItemId}_${uploadImageParams.ppeFileType}.${fileExtension}`;
    const obj = {
      id,
      uploadImageTabName: tabPosition,
      uploadedImageFileName: `${position}.${fileExtension}`,
      uploadedImageUrl: uploadedImages[position],
      showUploadRemoveButton: true,
      toggleRemoveBackground: removeBackgrounds[removeBackground],
      enableRemoveBackground: true,
      isImageLoading: false,
      imageSize: imageSizes[imageSize],
      imagePlacement: imagePlacements[imagePlacement],
      imagePlacementValue: imagePlacementValues[imagePlacement],
      logoColors: Number(logoColor),
    };
    return obj;
  };

  /** TODO this need to be refactored javascript is weird right! */
  uploadImageParams.params.forEach((item) => {
    if (item.includes('front')) {
      uploadImages.push(generateUploadImage(item, 1, 'Front'));
    } else if (item.includes('left')) {
      uploadImages.push(generateUploadImage(item, 2, 'Left'));
    } else if (item.includes('back')) {
      uploadImages.push(generateUploadImage(item, 3, 'Back'));
    } else if (item.includes('right')) {
      uploadImages.push(generateUploadImage(item, 4, 'Right'));
    }
  });

  return uploadImages;
};

export const getUploadImagesParams = (uploadImageParam) => {
  let params = uploadImageParam.replace('104878-Upload-Logo-', '').split(',');
  params = [...new Set(params)]; // removing duplicates
  const uploadImageInfo = params.shift();
  const lineItemId = uploadImageInfo.split('-')[0].replace(/_/g, '-');
  const uploadType = uploadImageInfo.split('-')[1];
  const ppeFileType = uploadImageInfo.split('-')[2];
  return {
    params,
    lineItemId,
    uploadType,
    ppeFileType,
  };
};

export const getUnUploadedPositions = (uploadedImages, uploadedPositions) => {
  const unUploadedPositions = uploadedImages.filter((uploadedImage) =>
    uploadedPositions.every((uploadedPosition) => uploadedPosition.id !== uploadedImage.id)
  );
  return unUploadedPositions;
};

export const updateUploadImageChooseOptions = (updatedImage, uploadImagesUrl, logoPosition) => {
  const toggleValue = updatedImage.toggleRemoveBackground ? 'T' : 'F';
  const toggleFileName = getFileExtension(updatedImage.uploadedImageFileName);
  const imagePlacementValue = updatedImage.imagePlacementValue
    ? updatedImage.imagePlacementValue[0]
    : 'none';
  const imageSize = updatedImage.imageSize ? updatedImage.imageSize[0] : 'none';
  const logoColor = updatedImage.logoColors ?? 1;
  let updatedUploadUrl = uploadImagesUrl?.split(',');
  updatedUploadUrl = updatedUploadUrl
    .filter((item) => !item.includes(logoPosition.toLowerCase()))
    .join(',');
  updatedUploadUrl = `${updatedUploadUrl},${updatedImage.uploadImageTabName.toLowerCase()}-${toggleValue}-${imageSize}-${imagePlacementValue}-${logoColor}-${toggleFileName}`;
  return updatedUploadUrl;
};

export const getUpdatedImagesUrlOnATB = (lineItemId, uploadImagesUrl) => {
  const updatedImagesUrl = uploadImagesUrl.split('-');
  updatedImagesUrl[0] = lineItemId.replace(/-/g, '_');
  return updatedImagesUrl.join('-');
};

export const getUrlLineItemId = (uploadImagesUrl) => {
  const uploadImagesParams = uploadImagesUrl.split('-');
  return uploadImagesParams[0].replace(/_/g, '-');
};
